import { render, staticRenderFns } from "./TireRegisterInputImage.vue?vue&type=template&id=0dce2b32&scoped=true"
import script from "./TireRegisterInputImage.vue?vue&type=script&lang=ts"
export * from "./TireRegisterInputImage.vue?vue&type=script&lang=ts"
import style0 from "./TireRegisterInputImage.vue?vue&type=style&index=0&id=0dce2b32&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0dce2b32",
  null
  
)

export default component.exports